export function getMarketApiHealthEndpoint(): string {
    return `/health-api`;
}
